module.exports = __webpack_public_path__ + "static/media/use-case-12.dc093676.jpg";